<div  class="flex flex-row justify-between items-center mb-3"
>
<div class="flex flex-row items-center">
  <span *ngIf="isEditable()" class="drag-handle pi pi-bars cursor-move mr-2" cdkDragHandle></span>
  <!--<h3 class="text-xl">{{ data().label }}</h3>-->
</div>
  
 @if(isEditable()) {
  <div class="flex top-5 right-5">
    <p-button icon="pi pi-cog" class="settings-button" (click)="showOptions.set(true)"></p-button>
  </div>
 }

</div>
